import { useState, useEffect } from "react";
import { t } from "../../i18n/translations";


export default function WishlistModal({
  showWishlistModal,
  setShowWishlistModal,
  userProfile,
  existingWishlists,
  wishlistChoice,
  setWishlistChoice,
  setSelectedExistingId,
  confirmWishlistChoice,
  setPendingJoinFamilyId,
  setPendingNewGroupId,
  setActiveTab,
  activeTab,
  lang,
  newWishlistName,
  setNewWishlistName,
  newGroupName,
  setNewGroupName,
  pendingNewGroupId,
}) {
  const tr = (key) => t(lang, key);
  // ── useState must be called BEFORE any early return ──
  const [showExistingPicker, setShowExistingPicker] = useState(false);
  const [selectedWl, setSelectedWl] = useState(null);
  
  // Resetear cuando el modal se abre/cierra
useEffect(() => {
  if (!showWishlistModal) {
    setShowExistingPicker(false);
    setSelectedWl(null);
  }
}, [showWishlistModal]);

  if (!showWishlistModal) return null;

  const primaryId = userProfile?.primaryWishlistId;
  const primaryWl = existingWishlists.find((w) => w.id === primaryId) || (primaryId ? null : existingWishlists[0]);
  const hasMultipleExisting = existingWishlists.length > 1;

  // Use selectedWl state or fall back to primaryWl/first
  const currentSelectedWl = selectedWl || primaryWl || existingWishlists[0] || null;

  const handleSelectExisting = (wl) => {
    setSelectedWl(wl);
    setSelectedExistingId(wl.id);
    setWishlistChoice("existing");
    setShowExistingPicker(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, marginBottom: 6 }}>
          {tr("wishlistChoice")}
        </h3>
        <p style={{ fontSize: 13, color: "#999", marginBottom: 18 }}>
          {lang === "es"
            ? "¿Con qué Wishlu quieres unirte a este grupo?"
            : lang === "fi"
            ? "Millä Wishlu-listalla haluat liittyä tähän ryhmään?"
            : "Which Wishlu do you want to use for this group?"}
        </p>
        {/* Campo nombre del grupo — solo al crear grupo nuevo */}
{pendingNewGroupId && (
  <div style={{ marginBottom: 16 }}>
    <label style={{ fontSize: 12, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: 6 }}>
      {lang === "es" ? "Nombre del grupo" : lang === "fi" ? "Ryhmän nimi" : "Group name"}
    </label>
    <input
      className="campo-input"
      style={{ margin: 0 }}
      placeholder={lang === "es" ? "Ej: Familia Navidad 🎄" : lang === "fi" ? "Esim: Perhe Joulu 🎄" : "e.g. Family Christmas 🎄"}
      value={newGroupName || ""}
      onChange={(e) => setNewGroupName && setNewGroupName(e.target.value)}
      autoFocus
    />
  </div>
)}

        {/* ── OPTION: Use existing wishlist ── */}
        {existingWishlists.length > 0 && (
          <div
            className={"opcion-card" + (wishlistChoice === "existing" ? " selected" : "")}
            onClick={() => {
              setWishlistChoice("existing");
              const wl = currentSelectedWl;
              if (wl) { setSelectedWl(wl); setSelectedExistingId(wl.id); }
            }}
          >
            <div className="opcion-titulo">
              📋 {lang === "es" ? "Usar Wishlu existente" : lang === "fi" ? "Käytä olemassa olevaa" : "Use existing Wishlu"}
            </div>

            {wishlistChoice === "existing" && currentSelectedWl && (
              <div style={{ marginTop: 10 }}>
                <div
                  style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "rgba(0,0,0,0.04)", borderRadius: 10, padding: "10px 12px", cursor: hasMultipleExisting ? "pointer" : "default" }}
                  onClick={(e) => { e.stopPropagation(); if (hasMultipleExisting) setShowExistingPicker((v) => !v); }}
                >
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{currentSelectedWl.name}</div>
                    <div style={{ fontSize: 11, color: "#999" }}>{(currentSelectedWl.gifts || []).length} {tr("gifts")}</div>
                  </div>
                  {hasMultipleExisting && (
                    <span style={{ fontSize: 12, color: "#d4a853" }}>▾ {lang === "es" ? "cambiar" : "change"}</span>
                  )}
                </div>

                {showExistingPicker && (
                  <div style={{ marginTop: 6, border: "1px solid #e8e2d9", borderRadius: 10, overflow: "hidden" }}>
                    {existingWishlists.map((wl) => (
                      <div
                        key={wl.id}
                        style={{ padding: "10px 14px", cursor: "pointer", background: currentSelectedWl?.id === wl.id ? "#fffdf5" : "#fff", borderBottom: "1px solid #f0ece6", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                        onClick={(e) => { e.stopPropagation(); handleSelectExisting(wl); }}
                      >
                        <div>
                          <div style={{ fontSize: 13, fontWeight: currentSelectedWl?.id === wl.id ? 600 : 400 }}>{wl.name}</div>
                          <div style={{ fontSize: 11, color: "#999" }}>{(wl.gifts || []).length} {tr("gifts")}</div>
                        </div>
                        {currentSelectedWl?.id === wl.id && <span style={{ color: "#d4a853" }}>✓</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {wishlistChoice !== "existing" && (
              <div className="opcion-desc" style={{ marginTop: 4 }}>
                {existingWishlists.length === 1
                  ? existingWishlists[0].name
                  : lang === "es"
                  ? `${existingWishlists.length} Wishlus disponibles`
                  : `${existingWishlists.length} Wishlus available`}
              </div>
            )}
          </div>
        )}

        {/* ── OPTION: Create new wishlist ── */}
        <div
          className={"opcion-card" + (wishlistChoice === "new" ? " selected" : "")}
          onClick={() => { setWishlistChoice("new"); setSelectedExistingId(null); }}
        >
          <div className="opcion-titulo">✨ {tr("createNewList")}</div>
          <div className="opcion-desc" style={{ fontSize: 11, color: "#aaa" }}>
            {lang === "es" ? "Solo para este grupo" : lang === "fi" ? "Vain tälle ryhmälle" : "Only for this group"}
          </div>

          {wishlistChoice === "new" && (
            <div style={{ marginTop: 10 }} onClick={(e) => e.stopPropagation()}>
              <input
                className="campo-input"
                style={{ margin: 0 }}
                placeholder={
                  lang === "es" ? "Ej: Mi Wishlu Europa 🇪🇺"
                  : lang === "fi" ? "Esim: Toivelistani"
                  : "e.g. My Europe Wishlu 🇪🇺"
                }
                value={newWishlistName || ""}
                onChange={(e) => setNewWishlistName && setNewWishlistName(e.target.value)}
                autoFocus
              />
            </div>
          )}
        </div>

        <button className="btn btn-dorado btn-full" style={{ marginTop: 8 }} onClick={confirmWishlistChoice}>
          {tr("confirm")}
        </button>
        <button className="btn btn-gris btn-full" style={{ marginTop: 8 }} onClick={() => {
          setShowWishlistModal(false);
          setPendingJoinFamilyId(null);
          setPendingNewGroupId(null);
          if (activeTab !== "groups") setActiveTab("profile");
        }}>
          {tr("cancel")}
        </button>
      </div>
    </div>
  );
}
